<template>
  <div class="card card-modern">
    <div class="card-body py-4">
      <div class="row align-items-center">
        <div class="col-6 col-md-4">
          <h3 class="text-4-1 my-0">Ukupno korisnika</h3>
          <strong class="text-6 text-color-dark">{{ dashboardData.totalActiveCustomersCount }}</strong>
        </div>
        <div
          class="
            col-6 col-md-4
            border
            border-top-0
            border-end-0
            border-bottom-0
            border-color-light-grey
            py-3
          "
        >
          <h3 class="text-4-1 text-color-success line-height-2 my-0">
            Korisnici <strong>↑</strong>
          </h3>
          <span>30 dana</span>
        </div>
        <div class="col-md-4 text-left text-md-right pe-md-4 mt-4 mt-md-0">
          <i class="
                      bx bx-user
                      icon icon-inline icon-xl
                      bg-primary
                      rounded-circle
                      text-color-light
                    "></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'UsersCard',
  computed: {
    dashboardData() {
      return this.$store.getters.getDashboardData;
    },
  },
};
</script>